// this is generated via google sheet json export
export default {
  seoTitle: "College Football Picks College Football Predictions with Expert Analysis",
  news: {
    seoTitle: "College Football Sports Betting News | BetQL",
  },
  description:
    "Outsmart Vegas with daily college football picks. Check out the latest NCAAF predictions, daily value bets and game analytics.",
  "free-pick-predictions": {
    seoTitle: "Free College Football Picks | College Football Predictions | BetQL",
    h1: "BetQL Free College Football Picks",
  },
  "best-bets": {
    seoTitle: "College Football Spreads | College Football Odds | BetQL",
    h1: "College Football Trending Bets",
    description:
      "Check out BetQL for the latest College Football odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
  },
  "line-movement": {
    seoTitle: "College Football Line Movement | NCAAF Line Movement Tracker | BetQL",
    h1: "College Football Line Movement",
    description:
      "Check out BetQL for the latest College Football line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
    "first-half-lines": {
      seoTitle: "College Football 1st Half Line Movement | BetQL",
      h1: "College Football 1st Half Line Movement",
      description:
        "Check out BetQL for the latest College Football 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "College Football 1st Half Line Movement - All | BetQL",
        h1: "All College Football 1st Half Line Movement",
        description:
          "Check out BetQL for the latest College Football 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "american-athletic": {
        seoTitle: "AAC Football 1st Half Line Movement",
        h1: "AAC Football - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest AAC football 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Football 1st Half Line Movement",
        h1: "ACC Football - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest ACC football 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Football 1st Half Line Movement",
        h1: "Big 12 Football - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest Big 12 football 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Football 1st Half Line Movement",
        h1: "Big 10 Football - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest Big 10 football 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Football 1st Half Line Movement",
        h1: "CUSA Football - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest CUSA football 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "fbs-independents": {
        seoTitle: "Independents Football 1st Half Line Movement",
        h1: "Independents Football - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest Independents football 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mid-american": {
        seoTitle: "MAC Football 1st Half Line Movement",
        h1: "MAC Football - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest MAC football 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "MW Football 1st Half Line Movement",
        h1: "MW Football - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest MW football 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Football 1st Half Line Movement",
        h1: "Pac 12 Football - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest Pac 12 football 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Football 1st Half Line Movement",
        h1: "SEC Football - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest SEC football 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Football 1st Half Line Movement",
        h1: "Sun Belt Football - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest Sun Belt football 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "first-half-moneyline": {
      seoTitle: "College Football 1st Half Money Line Movement | BetQL",
      h1: "College Football 1st Half Money Line Movement",
      description:
        "Check out BetQL for the latest College Football 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "College Football 1st Half Money Line Movement - All | BetQL",
        h1: "All College Football 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest College Football 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "american-athletic": {
        seoTitle: "AAC Football 1st Half Money Line Movement",
        h1: "AAC Football - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest AAC football 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL",
      },
      "atlantic-coast": {
        seoTitle: "ACC Football 1st Half Money Line Movement",
        h1: "ACC Football - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest ACC football 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL",
      },
      "big-12": {
        seoTitle: "Big 12 Football 1st Half Money Line Movement",
        h1: "Big 12 Football - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest Big 12 football 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL",
      },
      "big-ten": {
        seoTitle: "Big 10 Football 1st Half Money Line Movement",
        h1: "Big 10 Football - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest Big 10 football 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL",
      },
      "conference-usa": {
        seoTitle: "CUSA Football 1st Half Money Line Movement",
        h1: "CUSA Football - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest CUSA football 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL",
      },
      "fbs-independents": {
        seoTitle: "Independents Football 1st Half Money Line Movement",
        h1: "Independents Football - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest Independents football 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL",
      },
      "mid-american": {
        seoTitle: "MAC Football 1st Half Money Line Movement",
        h1: "MAC Football - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest MAC football 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL",
      },
      "mountain-west": {
        seoTitle: "MW Football 1st Half Money Line Movement",
        h1: "MW Football - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest MW football 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL",
      },
      "pac-12": {
        seoTitle: "Pac 12 Football 1st Half Money Line Movement",
        h1: "Pac 12 Football - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest Pac 12 football 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL",
      },
      sec: {
        seoTitle: "SEC Football 1st Half Money Line Movement",
        h1: "SEC Football - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest SEC football 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Football 1st Half Money Line Movement",
        h1: "Sun Belt Football - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest Sun Belt football 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL",
      },
    },
    "first-half-totals-spread": {
      seoTitle: "NCAAF Line Movement 1st Half Total Top 25 | BetQL",
      h1: "College Football 1st Half Over Under Line Movement",
      description:
        "Check out BetQL for the latest College Football 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAF Line Movement 1st Half Total All Conferences | BetQL",
        h1: "All College Football 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest College Football 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "american-athletic": {
        seoTitle: "AAC Football 1st Half Over Under Line Movement | BetQL",
        h1: "AAC Football - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest AAC football 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL",
      },
      "atlantic-coast": {
        seoTitle: "ACC Football 1st Half Over Under Line Movement | BetQL",
        h1: "ACC Football - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest ACC football 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL",
      },
      "big-12": {
        seoTitle: "Big 12 Football 1st Half Over Under Line Movement | BetQL",
        h1: "Big 12 Football - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest Big 12 football 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL",
      },
      "big-ten": {
        seoTitle: "Big 10 Football 1st Half Over Under Line Movement | BetQL",
        h1: "Big 10 Football - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest Big 10 football 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL",
      },
      "conference-usa": {
        seoTitle: "CUSA Football 1st Half Over Under Line Movement | BetQL",
        h1: "CUSA Football - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest CUSA football 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL",
      },
      "fbs-independents": {
        seoTitle: "Independents Football 1st Half Over Under Line Movement | BetQL",
        h1: "Independents Football - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest Independents football 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL",
      },
      "mid-american": {
        seoTitle: "MAC Football 1st Half Over Under Line Movement | BetQL",
        h1: "MAC Football - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest MAC football 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL",
      },
      "mountain-west": {
        seoTitle: "MW Football 1st Half Over Under Line Movement | BetQL",
        h1: "MW Football - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest MW football 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL",
      },
      "pac-12": {
        seoTitle: "Pac 12 Football 1st Half Over Under Line Movement | BetQL",
        h1: "Pac 12 Football - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest Pac 12 football 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL",
      },
      sec: {
        seoTitle: "SEC Football 1st Half Over Under Line Movement | BetQL",
        h1: "SEC Football - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest SEC football 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Football 1st Half Over Under Line Movement | BetQL",
        h1: "Sun Belt Football - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest Sun Belt football 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL",
      },
    },
    moneyline: {
      seoTitle: "College Football Money Line Movement | BetQL",
      h1: "College Football Money Line Movement",
      description:
        "Check out BetQL for the latest College Football money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAF Line Movement Moneyline All Conferences | BetQL",
        h1: "All College Football Money Line Movement",
        description:
          "Check out BetQL for the latest College Football money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "american-athletic": {
        seoTitle: "AAC Football Money Line Movement | BetQL",
        h1: "AAC Football - Money Line Movement",
        description:
          "Check out BetQL for the latest AAC football money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Football Money Line Movement | BetQL",
        h1: "ACC Football - Money Line Movement",
        description:
          "Check out BetQL for the latest ACC football money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Football Money Line Movement | BetQL",
        h1: "Big 12 Football - Money Line Movement",
        description:
          "Check out BetQL for the latest Big 12 football money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Football Money Line Movement | BetQL",
        h1: "Big 10 Football - Money Line Movement",
        description:
          "Check out BetQL for the latest Big 10 football money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Football Money Line Movement | BetQL",
        h1: "CUSA Football - Money Line Movement",
        description:
          "Check out BetQL for the latest CUSA football money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "fbs-independents": {
        seoTitle: "Independents Football Money Line Movement | BetQL",
        h1: "Independents Football - Money Line Movement",
        description:
          "Check out BetQL for the latest Independents football money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mid-american": {
        seoTitle: "MAC Football Money Line Movement | BetQL",
        h1: "MAC Football - Money Line Movement",
        description:
          "Check out BetQL for the latest MAC football money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "MW Football Money Line Movement | BetQL",
        h1: "MW Football - Money Line Movement",
        description:
          "Check out BetQL for the latest MW football money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Football Money Line Movement | BetQL",
        h1: "Pac 12 Football - Money Line Movement",
        description:
          "Check out BetQL for the latest Pac 12 football money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Football Money Line Movement | BetQL",
        h1: "SEC Football - Money Line Movement",
        description:
          "Check out BetQL for the latest SEC football money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Football Money Line Movement | BetQL",
        h1: "Sun Belt Football - Money Line Movement",
        description:
          "Check out BetQL for the latest Sun Belt football money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "second-half-lines": {
      seoTitle: "College Football 2nd Half Line Movement | BetQL",
      h1: "College Football 2nd Half Line Movement",
      description:
        "Check out BetQL for the latest College Football 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAF Line Movement 2nd Half Spread All Conferences | BetQL",
        h1: "All College Football 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest College Football 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "american-athletic": {
        seoTitle: "AAC Football 2nd Half Line Movement | BetQL",
        h1: "AAC Football - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest AAC football 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Football 2nd Half Line Movement | BetQL",
        h1: "ACC Football - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest ACC football 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Football 2nd Half Line Movement | BetQL",
        h1: "Big 12 Football - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest Big 12 football 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Football 2nd Half Line Movement | BetQL",
        h1: "Big 10 Football - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest Big 10 football 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Football 2nd Half Line Movement | BetQL",
        h1: "CUSA Football - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest CUSA football 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "fbs-independents": {
        seoTitle: "Independents Football 2nd Half Line Movement | BetQL",
        h1: "Independents Football - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest Independents football 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mid-american": {
        seoTitle: "MAC Football 2nd Half Line Movement | BetQL",
        h1: "MAC Football - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest MAC football 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "MW Football 2nd Half Line Movement | BetQL",
        h1: "MW Football - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest MW football 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Football 2nd Half Line Movement | BetQL",
        h1: "Pac 12 Football - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest Pac 12 football 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Football 2nd Half Line Movement | BetQL",
        h1: "SEC Football - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest SEC football 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Football 2nd Half Line Movement | BetQL",
        h1: "Sun Belt Football - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest Sun Belt football 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "second-half-moneylines": {
      seoTitle: "College Football 2nd Half Money Line Movement | BetQL",
      h1: "College Football 2nd Half Money Line Movement",
      description:
        "Check out BetQL for the latest College Football 2nd half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAF Line Movement 2nd Half Moneyline All Conferences | BetQL",
        h1: "All College Football 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest College Football 2nd half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "american-athletic": {
        seoTitle: "AAC Football 2nd Half Money Line Movement | BetQL",
        h1: "AAC Football - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest AAC football 2nd half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Football 2nd Half Money Line Movement | BetQL",
        h1: "ACC Football - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest ACC football 2nd half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Football 2nd Half Money Line Movement | BetQL",
        h1: "Big 12 Football - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest Big 12 football 2nd half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Football 2nd Half Money Line Movement | BetQL",
        h1: "Big 10 Football - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest Big 10 football 2nd half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Football 2nd Half Money Line Movement | BetQL",
        h1: "CUSA Football - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest CUSA football 2nd half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "fbs-independents": {
        seoTitle: "Independents Football 2nd Half Money Line Movement | BetQL",
        h1: "Independents Football - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest Independents football 2nd half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mid-american": {
        seoTitle: "MAC Football 2nd Half Money Line Movement | BetQL",
        h1: "MAC Football - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest MAC football 2nd half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "MW Football 2nd Half Money Line Movement | BetQL",
        h1: "MW Football - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest MW football 2nd half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Football 2nd Half Money Line Movement | BetQL",
        h1: "Pac 12 Football - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest Pac 12 football 2nd half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Football 2nd Half Money Line Movement | BetQL",
        h1: "SEC Football - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest SEC football 2nd half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Football 2nd Half Money Line Movement | BetQL",
        h1: "Sun Belt Football - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest Sun Belt football 2nd half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    spread: {
      all: {
        seoTitle: "College Football Spread Line Movement | BetQL",
        h1: "All College Football Spread Line Movement",
        description:
          "Check out BetQL for the latest College Football spread line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "american-athletic": {
        seoTitle: "AAC Football Spread Line Movement | BetQL",
        h1: "AAC Football - Spread Line Movement",
        description:
          "Check out BetQL for the latest AAC football spread line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Football Spread Line Movement | BetQL",
        h1: "ACC Football - Spread Line Movement",
        description:
          "Check out BetQL for the latest ACC football spread line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Football Spread Line Movement | BetQL",
        h1: "Big 12 Football - Spread Line Movement",
        description:
          "Check out BetQL for the latest Big 12 football spread line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Football Spread Line Movement | BetQL",
        h1: "Big 10 Football - Spread Line Movement",
        description:
          "Check out BetQL for the latest Big 10 football spread line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Football Spread Line Movement | BetQL",
        h1: "CUSA Football - Spread Line Movement",
        description:
          "Check out BetQL for the latest CUSA football spread line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "fbs-independents": {
        seoTitle: "Independents Football Spread Line Movement | BetQL",
        h1: "Independents Football - Spread Line Movement",
        description:
          "Check out BetQL for the latest Independents football spread line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mid-american": {
        seoTitle: "MAC Football Spread Line Movement | BetQL",
        h1: "MAC Football - Spread Line Movement",
        description:
          "Check out BetQL for the latest MAC football spread line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "MW Football Spread Line Movement | BetQL",
        h1: "MW Football - Spread Line Movement",
        description:
          "Check out BetQL for the latest MW football spread line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Football Spread Line Movement | BetQL",
        h1: "Pac 12 Football - Spread Line Movement",
        description:
          "Check out BetQL for the latest Pac 12 football spread line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Football Spread Line Movement | BetQL",
        h1: "SEC Football - Spread Line Movement",
        description:
          "Check out BetQL for the latest SEC football spread line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Football Spread Line Movement | BetQL",
        h1: "Sun Belt Football - Spread Line Movement",
        description:
          "Check out BetQL for the latest Sun Belt football spread line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "totals-spread": {
      seoTitle: "College Football Over Under Line Movement | NCAAF Totals Line Movement",
      h1: "College Football Over Under Line Movement",
      description:
        "Check out BetQL for the latest College Football over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAF Over Under Line Movement All Conferences | BetQL",
        h1: "All College Football Over Under Line Movement",
        description:
          "Check out BetQL for the latest College Football over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "american-athletic": {
        seoTitle: "AAC Football Over Under Line Movement | BetQL",
        h1: "AAC Football - Over Under Line Movement",
        description:
          "Check out BetQL for the latest AAC football over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Football Over Under Line Movement | BetQL",
        h1: "ACC Football - Over Under Line Movement",
        description:
          "Check out BetQL for the latest ACC football over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Football Over Under Line Movement | BetQL",
        h1: "Big 12 Football - Over Under Line Movement",
        description:
          "Check out BetQL for the latest Big 12 football over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Football Over Under Line Movement | BetQL",
        h1: "Big 10 Football - Over Under Line Movement",
        description:
          "Check out BetQL for the latest Big 10 football over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Football Over Under Line Movement | BetQL",
        h1: "CUSA Football - Over Under Line Movement",
        description:
          "Check out BetQL for the latest CUSA football over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "fbs-independents": {
        seoTitle: "Independents Football Over Under Line Movement | BetQL",
        h1: "Independents Football - Over Under Line Movement",
        description:
          "Check out BetQL for the latest Independents football over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mid-american": {
        seoTitle: "MAC Football Over Under Line Movement | BetQL",
        h1: "MAC Football - Over Under Line Movement",
        description:
          "Check out BetQL for the latest MAC football over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "MW Football Over Under Line Movement | BetQL",
        h1: "MW Football - Over Under Line Movement",
        description:
          "Check out BetQL for the latest MW football over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Football Over Under Line Movement | BetQL",
        h1: "Pac 12 Football - Over Under Line Movement",
        description:
          "Check out BetQL for the latest Pac 12 football over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Football Over Under Line Movement | BetQL",
        h1: "SEC Football - Over Under Line Movement",
        description:
          "Check out BetQL for the latest SEC football over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Football Over Under Line Movement | BetQL",
        h1: "Sun Belt Football - Over Under Line Movement",
        description:
          "Check out BetQL for the latest Sun Belt football over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
  },
  odds: {
    seoTitle: "College Football Lines | College Football Spreads | BetQL",
    h1: "College Football Model Bets for Today",
    description:
      "Check out BetQL for the latest College Football lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
    "first-half-lines": {
      seoTitle: "College Football 1st Half Lines | BetQL",
      h1: "College Football 1st Half Model Bets",
      description:
        "Check out BetQL for the latest College Football 1st half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAF Odds 1st Half Spread All Conferences | BetQL",
        h1: "All College Football 1st Half Model Bets",
        description:
          "Check out BetQL for the latest College Football 1st half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "american-athletic": {
        seoTitle: "AAC Football 1st Half Lines | BetQL",
        h1: "AAC Football - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest AAC football 1st half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Football 1st Half Lines | BetQL",
        h1: "ACC Football - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest ACC football 1st half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Football 1st Half Lines | BetQL",
        h1: "Big 12 Football - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest Big 12 football 1st half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Football 1st Half Lines | BetQL",
        h1: "Big 10 Football - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest Big 10 football 1st half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Football 1st Half Lines | BetQL",
        h1: "CUSA Football - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest CUSA football 1st half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "fbs-independents": {
        seoTitle: "Independents Football 1st Half Lines | BetQL",
        h1: "Independents Football - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest Independents football 1st half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mid-american": {
        seoTitle: "MAC Football 1st Half Lines | BetQL",
        h1: "MAC Football - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest MAC football 1st half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "MW Football 1st Half Lines | BetQL",
        h1: "MW Football - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest MW football 1st half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Football 1st Half Lines | BetQL",
        h1: "Pac 12 Football - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest Pac 12 football 1st half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Football 1st Half Lines | BetQL",
        h1: "SEC Football - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest SEC football 1st half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Football 1st Half Lines | BetQL",
        h1: "Sun Belt Football - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest Sun Belt football 1st half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    moneyline: {
      seoTitle: "College Football Moneyline | College Football Money Lines | BetQL",
      h1: "College Football Money Line Model Bets",
      description:
        "Check out BetQL for the latest College Football money lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAF Odds Moneyline All Conferences | BetQL",
        h1: "All College Football Money Line Model Bets",
        description:
          "Check out BetQL for the latest College Football money lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "american-athletic": {
        seoTitle: "AAC Football Money Lines | BetQL",
        h1: "AAC Football - Money Line Model Bets",
        description:
          "Check out BetQL for the latest AAC football money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Football Money Lines | BetQL",
        h1: "ACC Football - Money Line Model Bets",
        description:
          "Check out BetQL for the latest ACC football money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Football Money Lines | BetQL",
        h1: "Big 12 Football - Money Line Model Bets",
        description:
          "Check out BetQL for the latest Big 12 football money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Football Money Lines | BetQL",
        h1: "Big 10 Football - Money Line Model Bets",
        description:
          "Check out BetQL for the latest Big 10 football money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Football Money Lines | BetQL",
        h1: "CUSA Football - Money Line Model Bets",
        description:
          "Check out BetQL for the latest CUSA football money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "fbs-independents": {
        seoTitle: "Independents Football Money Lines | BetQL",
        h1: "Independents Football - Money Line Model Bets",
        description:
          "Check out BetQL for the latest Independents football money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mid-american": {
        seoTitle: "MAC Football Money Lines | BetQL",
        h1: "MAC Football - Money Line Model Bets",
        description:
          "Check out BetQL for the latest MAC football money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "MW Football Money Lines | BetQL",
        h1: "MW Football - Money Line Model Bets",
        description:
          "Check out BetQL for the latest MW football money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Football Money Lines | BetQL",
        h1: "Pac 12 Football - Money Line Model Bets",
        description:
          "Check out BetQL for the latest Pac 12 football money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Football Money Lines | BetQL",
        h1: "SEC Football - Money Line Model Bets",
        description:
          "Check out BetQL for the latest SEC football money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Football Money Lines | BetQL",
        h1: "Sun Belt Football - Money Line Model Bets",
        description:
          "Check out BetQL for the latest Sun Belt football money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "second-half-lines": {
      seoTitle: "College Football 2nd Half Lines | College Football 2nd Half Odds | BetQL",
      h1: "College Football 2nd Half Model Bets",
      description:
        "Check out BetQL for the latest College Football 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAF Odds 2nd Half Spread All Conferences | BetQL",
        h1: "All College Football 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest College Football 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "american-athletic": {
        seoTitle: "AAC Football 2nd Half Lines | BetQL",
        h1: "AAC Football - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest AAC football 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Football 2nd Half Lines | BetQL",
        h1: "ACC Football - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest ACC football 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Football 2nd Half Lines | BetQL",
        h1: "Big 12 Football - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest Big 12 football 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Football 2nd Half Lines | BetQL",
        h1: "Big 10 Football - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest Big 10 football 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Football 2nd Half Lines | BetQL",
        h1: "CUSA Football - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest CUSA football 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "fbs-independents": {
        seoTitle: "Independents Football 2nd Half Lines | BetQL",
        h1: "Independents Football - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest Independents football 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mid-american": {
        seoTitle: "MAC Football 2nd Half Lines | BetQL",
        h1: "MAC Football - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest MAC football 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "MW Football 2nd Half Lines | BetQL",
        h1: "MW Football - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest MW football 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Football 2nd Half Lines | BetQL",
        h1: "Pac 12 Football - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest Pac 12 football 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Football 2nd Half Lines | BetQL",
        h1: "SEC Football - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest SEC football 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Football 2nd Half Lines | BetQL",
        h1: "Sun Belt Football - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest Sun Belt football 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "totals-spread": {
      seoTitle: "College Football Over Unders | College Football Totals | BetQL",
      h1: "College Football Over Under Picks",
      description:
        "Check out BetQL for the latest College Football over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAF Odds Total All Conferences | BetQL",
        h1: "All College Football Over Under Picks",
        description:
          "Check out BetQL for the latest College Football over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "american-athletic": {
        seoTitle: "AAC Football Over Unders | BetQL",
        h1: "AAC Football - Over Under Picks",
        description:
          "Check out BetQL for the latest AAC football over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Football Over Unders | BetQL",
        h1: "ACC Football - Over Under Picks",
        description:
          "Check out BetQL for the latest ACC football over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Football Over Unders | BetQL",
        h1: "Big 12 Football - Over Under Picks",
        description:
          "Check out BetQL for the latest Big 12 football over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Football Over Unders | BetQL",
        h1: "Big 10 Football - Over Under Picks",
        description:
          "Check out BetQL for the latest Big 10 football over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Football Over Unders | BetQL",
        h1: "CUSA Football - Over Under Picks",
        description:
          "Check out BetQL for the latest CUSA football over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "fbs-independents": {
        seoTitle: "Independents Football Over Unders | BetQL",
        h1: "Independents Football - Over Under Picks",
        description:
          "Check out BetQL for the latest Independents football over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mid-american": {
        seoTitle: "MAC Football Over Unders | BetQL",
        h1: "MAC Football - Over Under Picks",
        description:
          "Check out BetQL for the latest MAC football over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "MW Football Over Unders | BetQL",
        h1: "MW Football - Over Under Picks",
        description:
          "Check out BetQL for the latest MW football over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Football Over Unders | BetQL",
        h1: "Pac 12 Football - Over Under Picks",
        description:
          "Check out BetQL for the latest Pac 12 football over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Football Over Unders | BetQL",
        h1: "SEC Football - Over Under Picks",
        description:
          "Check out BetQL for the latest SEC football over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Football Over Unders | BetQL",
        h1: "Sun Belt Football - Over Under Picks",
        description:
          "Check out BetQL for the latest Sun Belt football over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "first-half-moneyline": {
      seoTitle: "College Football 1st Half Money Lines | BetQL",
      h1: "College Football 1st Half Money Line Model Bets",
      description:
        "Check out BetQL for the latest College Football 1st half money lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAF 1st Half Money Line Odds | BetQL",
        h1: "All College Football 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest College Football 1st half money lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "american-athletic": {
        seoTitle: "AAC Football 1st Half Money Line Odds | BetQL",
        h1: "AAC Football - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest AAC football 1st half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Football 1st Half Money Line Odds | BetQL",
        h1: "ACC Football - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest ACC football 1st half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Football 1st Half Money Line Odds | BetQL",
        h1: "Big 12 Football - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Big 12 football 1st half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Football 1st Half Money Line Odds | BetQL",
        h1: "Big 10 Football - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Big 10 football 1st half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Football 1st Half Money Line Odds | BetQL",
        h1: "CUSA Football - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest CUSA football 1st half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "fbs-independents": {
        seoTitle: "Independents Football 1st Half Money Line Odds | BetQL",
        h1: "Independents Football - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Independents football 1st half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mid-american": {
        seoTitle: "MAC Football 1st Half Money Line Odds | BetQL",
        h1: "MAC Football - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest MAC football 1st half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "MW Football 1st Half Money Line Odds | BetQL",
        h1: "MW Football - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest MW football 1st half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Football 1st Half Money Line Odds | BetQL",
        h1: "Pac 12 Football - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Pac 12 football 1st half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Football 1st Half Money Line Odds | BetQL",
        h1: "SEC Football - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest SEC football 1st half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Football 1st Half Money Line Odds | BetQL",
        h1: "Sun Belt Football - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Sun Belt football 1st half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "first-half-totals-spread": {
      seoTitle: "NCAAF Odds 1st Half Total Top 25 | BetQL",
      h1: "College Football 1st Half Over Under Model Bets",
      description:
        "Check out BetQL for the latest College Football 1st half over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAF Odds 1st Half Total All Conferences | BetQL",
        h1: "All College Football 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest College Football 1st half over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "american-athletic": {
        seoTitle: "AAC Football 1st Half Over Unders | BetQL",
        h1: "AAC Football - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest AAC football 1st half over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Football 1st Half Over Unders | BetQL",
        h1: "ACC Football - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest ACC football 1st half over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Football 1st Half Over Unders | BetQL",
        h1: "Big 12 Football - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest Big 12 football 1st half over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Football 1st Half Over Unders | BetQL",
        h1: "Big 10 Football - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest Big 10 football 1st half over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Football 1st Half Over Unders | BetQL",
        h1: "CUSA Football - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest CUSA football 1st half over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "fbs-independents": {
        seoTitle: "Independents Football 1st Half Over Unders | BetQL",
        h1: "Independents Football - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest Independents football 1st half over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mid-american": {
        seoTitle: "MAC Football 1st Half Over Unders | BetQL",
        h1: "MAC Football - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest MAC football 1st half over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "MW Football 1st Half Over Unders | BetQL",
        h1: "MW Football - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest MW football 1st half over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Football 1st Half Over Unders | BetQL",
        h1: "Pac 12 Football - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest Pac 12 football 1st half over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Football 1st Half Over Unders | BetQL",
        h1: "SEC Football - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest SEC football 1st half over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Football 1st Half Over Unders | BetQL",
        h1: "Sun Belt Football - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest Sun Belt football 1st half over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "second-half-moneylines": {
      seoTitle: "College Football 2nd Half Money Lines | BetQL",
      h1: "College Football 2nd Half Money Line Model Bets",
      description:
        "Check out BetQL for the latest College Football 2nd half money lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAF Odds 2nd Half Moneyline All Conferences | BetQL",
        h1: "All College Football 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest College Football 2nd half money lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "american-athletic": {
        seoTitle: "AAC Football 2nd Half Money Lines | BetQL",
        h1: "AAC Football - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest AAC football 2nd money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Football 2nd Half Money Lines | BetQL",
        h1: "ACC Football - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest ACC football 2nd money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Football 2nd Half Money Lines | BetQL",
        h1: "Big 12 Football - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Big 12 football 2nd money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Football 2nd Half Money Lines | BetQL",
        h1: "Big 10 Football - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Big 10 football 2nd money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Football 2nd Half Money Lines | BetQL",
        h1: "CUSA Football - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest CUSA football 2nd money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "fbs-independents": {
        seoTitle: "Independents Football 2nd Half Money Lines | BetQL",
        h1: "Independents Football - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Independents football 2nd money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mid-american": {
        seoTitle: "MAC Football 2nd Half Money Lines | BetQL",
        h1: "MAC Football - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest MAC football 2nd money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "MW Football 2nd Half Money Lines | BetQL",
        h1: "MW Football - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest MW football 2nd money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Football 2nd Half Money Lines | BetQL",
        h1: "Pac 12 Football - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Pac 12 football 2nd money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Football 2nd Half Money Lines | BetQL",
        h1: "SEC Football - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest SEC football 2nd money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Football 2nd Half Money Lines | BetQL",
        h1: "Sun Belt Football - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Sun Belt football 2nd money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    spread: {
      all: {
        seoTitle: "NCAAF Odds Spread All Conferences | BetQL",
        h1: "All College Football ATS Model Bets",
        description:
          "Check out BetQL for the latest College Football spreads. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "american-athletic": {
        seoTitle: "AAC Football Spread Odds | BetQL",
        h1: "AAC Football - ATS Model Bets",
        description:
          "Check out BetQL for the latest AAC football spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Football Spread Odds | BetQL",
        h1: "ACC Football - ATS Model Bets",
        description:
          "Check out BetQL for the latest ACC football spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Football Spread Odds | BetQL",
        h1: "Big 12 Football - ATS Model Bets",
        description:
          "Check out BetQL for the latest Big 12 football spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Football Spread Odds | BetQL",
        h1: "Big 10 Football - ATS Model Bets",
        description:
          "Check out BetQL for the latest Big 10 football spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Football Spread Odds | BetQL",
        h1: "CUSA Football - ATS Model Bets",
        description:
          "Check out BetQL for the latest CUSA football spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "fbs-independents": {
        seoTitle: "Independents Football Spread Odds | BetQL",
        h1: "Independents Football - ATS Model Bets",
        description:
          "Check out BetQL for the latest Independents football spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mid-american": {
        seoTitle: "MAC Football Spread Odds | BetQL",
        h1: "MAC Football - ATS Model Bets",
        description:
          "Check out BetQL for the latest MAC football spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "MW Football Spread Odds | BetQL",
        h1: "MW Football - ATS Model Bets",
        description:
          "Check out BetQL for the latest MW football spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Football Spread Odds | BetQL",
        h1: "Pac 12 Football - ATS Model Bets",
        description:
          "Check out BetQL for the latest Pac 12 football spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Football Spread Odds | BetQL",
        h1: "SEC Football - ATS Model Bets",
        description:
          "Check out BetQL for the latest SEC football spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Football Spread Odds | BetQL",
        h1: "Sun Belt Football - ATS Model Bets",
        description:
          "Check out BetQL for the latest Sun Belt football spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
  },
  "public-betting": {
    seoTitle: "College Football Consensus Picks | College Football Public Betting | BetQL",
    h1: "College Football ATS Consensus Picks",
    description:
      "Check out BetQL for the latest College Football consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
    "first-half-lines": {
      seoTitle: "College Football 1st Half Public Picks | BetQL",
      h1: "College Football 1st Half Public Betting",
      description:
        "Check out BetQL for the latest College Football 1st half consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAF Public Betting 1st Half Spread All Conferences | BetQL",
        h1: "All College Football 1st Half Public Betting",
        description:
          "Check out BetQL for the latest College Football 1st half consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "american-athletic": {
        seoTitle: "AAC Football Public 1st Half Picks | BetQL",
        h1: "AAC Football - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest AAC football 1st half public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Football Public 1st Half Picks | BetQL",
        h1: "ACC Football - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest ACC football 1st half public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Football Public 1st Half Picks | BetQL",
        h1: "Big 12 Football - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest Big 12 football 1st half public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Football Public 1st Half Picks | BetQL",
        h1: "Big 10 Football - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest Big 10 football 1st half public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Football Public 1st Half Picks | BetQL",
        h1: "CUSA Football - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest CUSA football 1st half public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "fbs-independents": {
        seoTitle: "Independents Football Public 1st Half Picks | BetQL",
        h1: "Independents Football - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest Independents football 1st half public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mid-american": {
        seoTitle: "MAC Football Public 1st Half Picks | BetQL",
        h1: "MAC Football - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest MAC football 1st half public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "MW Football Public 1st Half Picks | BetQL",
        h1: "MW Football - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest MW football 1st half public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Football Public 1st Half Picks | BetQL",
        h1: "Pac 12 Football - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest Pac 12 football 1st half public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Football Public 1st Half Picks | BetQL",
        h1: "SEC Football - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest SEC football 1st half public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Football Public 1st Half Picks | BetQL",
        h1: "Sun Belt Football - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest Sun Belt football 1st half public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "first-half-moneyline": {
      seoTitle: "College Football 1st Half Public Moneyline Picks | BetQL",
      h1: "College Football 1st Half Money Line Public Picks",
      description:
        "Check out BetQL for the latest College Football 1st half money line consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAF Public Betting 1st Half Moneyline All Conferences | BetQL",
        h1: "All College Football 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest College Football 1st half money line consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "american-athletic": {
        seoTitle: "AAC Football Public 1st Half Money Line Picks | BetQL",
        h1: "AAC Football - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest AAC football 1st half money line public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Football Public 1st Half Money Line Picks | BetQL",
        h1: "ACC Football - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest ACC football 1st half money line public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Football Public 1st Half Money Line Picks | BetQL",
        h1: "Big 12 Football - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Big 12 football 1st half money line public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Football Public 1st Half Money Line Picks | BetQL",
        h1: "Big 10 Football - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Big 10 football 1st half money line public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Football Public 1st Half Money Line Picks | BetQL",
        h1: "CUSA Football - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest CUSA football 1st half money line public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "fbs-independents": {
        seoTitle: "Independents Football Public 1st Half Money Line Picks | BetQL",
        h1: "Independents Football - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Independents football 1st half money line public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mid-american": {
        seoTitle: "MAC Football Public 1st Half Money Line Picks | BetQL",
        h1: "MAC Football - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest MAC football 1st half money line public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "MW Football Public 1st Half Money Line Picks | BetQL",
        h1: "MW Football - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest MW football 1st half money line public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Football Public 1st Half Money Line Picks | BetQL",
        h1: "Pac 12 Football - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Pac 12 football 1st half money line public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Football Public 1st Half Money Line Picks | BetQL",
        h1: "SEC Football - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest SEC football 1st half money line public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Football Public 1st Half Money Line Picks | BetQL",
        h1: "Sun Belt Football - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Sun Belt football 1st half money line public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "first-half-totals-spread": {
      seoTitle: "NCAAF Public Betting 1st Half Total Top 25 | BetQL",
      h1: "College Football 1st Half Over Under Public Picks",
      description:
        "Check out BetQL for the latest College Football 1st half over under consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAF Public Betting 1st Half Total All Conferences | BetQL",
        h1: "All College Football 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest College Football 1st half over under consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "american-athletic": {
        seoTitle: "AAC Football Public 1st Half Over Unders | BetQL",
        h1: "AAC Football - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest AAC football 1st half over under public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Football Public 1st Half Over Unders | BetQL",
        h1: "ACC Football - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest ACC football 1st half over under public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Football Public 1st Half Over Unders | BetQL",
        h1: "Big 12 Football - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest Big 12 football 1st half over under public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Football Public 1st Half Over Unders | BetQL",
        h1: "Big 10 Football - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest Big 10 football 1st half over under public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Football Public 1st Half Over Unders | BetQL",
        h1: "CUSA Football - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest CUSA football 1st half over under public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "fbs-independents": {
        seoTitle: "Independents Football Public 1st Half Over Unders | BetQL",
        h1: "Independents Football - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest Independents football 1st half over under public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mid-american": {
        seoTitle: "MAC Football Public 1st Half Over Unders | BetQL",
        h1: "MAC Football - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest MAC football 1st half over under public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "MW Football Public 1st Half Over Unders | BetQL",
        h1: "MW Football - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest MW football 1st half over under public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Football Public 1st Half Over Unders | BetQL",
        h1: "Pac 12 Football - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest Pac 12 football 1st half over under public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Football Public 1st Half Over Unders | BetQL",
        h1: "SEC Football - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest SEC football 1st half over under public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Football Public 1st Half Over Unders | BetQL",
        h1: "Sun Belt Football - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest Sun Belt football 1st half over under public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    moneyline: {
      seoTitle: "College Football Consensus Money Line Picks | BetQL",
      h1: "College Football Money Line Public Picks",
      description:
        "Check out BetQL for the latest College Football money line consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAF Public Betting Moneyline All Conferences | BetQL",
        h1: "All College Football Money Line Public Picks",
        description:
          "Check out BetQL for the latest College Football money line consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "american-athletic": {
        seoTitle: "AAC Football Public Money Line Picks | BetQL",
        h1: "AAC Football - Money Line Public Betting",
        description:
          "Check out BetQL for the latest AAC football money line public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Football Public Money Line Picks | BetQL",
        h1: "ACC Football - Money Line Public Betting",
        description:
          "Check out BetQL for the latest ACC football money line public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Football Public Money Line Picks | BetQL",
        h1: "Big 12 Football - Money Line Public Betting",
        description:
          "Check out BetQL for the latest Big 12 football money line public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Football Public Money Line Picks | BetQL",
        h1: "Big 10 Football - Money Line Public Betting",
        description:
          "Check out BetQL for the latest Big 10 football money line public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Football Public Money Line Picks | BetQL",
        h1: "CUSA Football - Money Line Public Betting",
        description:
          "Check out BetQL for the latest CUSA football money line public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "fbs-independents": {
        seoTitle: "Independents Football Public Money Line Picks | BetQL",
        h1: "Independents Football - Money Line Public Betting",
        description:
          "Check out BetQL for the latest Independents football money line public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mid-american": {
        seoTitle: "MAC Football Public Money Line Picks | BetQL",
        h1: "MAC Football - Money Line Public Betting",
        description:
          "Check out BetQL for the latest MAC football money line public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "MW Football Public Money Line Picks | BetQL",
        h1: "MW Football - Money Line Public Betting",
        description:
          "Check out BetQL for the latest MW football money line public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Football Public Money Line Picks | BetQL",
        h1: "Pac 12 Football - Money Line Public Betting",
        description:
          "Check out BetQL for the latest Pac 12 football money line public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Football Public Money Line Picks | BetQL",
        h1: "SEC Football - Money Line Public Betting",
        description:
          "Check out BetQL for the latest SEC football money line public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Football Public Money Line Picks | BetQL",
        h1: "Sun Belt Football - Money Line Public Betting",
        description:
          "Check out BetQL for the latest Sun Belt football money line public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "second-half-lines": {
      seoTitle: "College Football 2nd Half Public Picks | BetQL",
      h1: "College Football 2nd Half Public Betting",
      description:
        "Check out BetQL for the latest College Football 2nd half consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAF Public Betting 2nd Half Spread All Conferences | BetQL",
        h1: "All College Football 2nd Half Public Betting",
        description:
          "Check out BetQL for the latest College Football 2nd half consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "american-athletic": {
        seoTitle: "AAC Football Public 2nd Half Picks | BetQL",
        h1: "AAC Football - 2nd Half Public Betting",
        description:
          "Check out BetQL for the latest AAC football 2nd half public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Football Public 2nd Half Picks | BetQL",
        h1: "ACC Football - 2nd Half Public Betting",
        description:
          "Check out BetQL for the latest ACC football 2nd half public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Football Public 2nd Half Picks | BetQL",
        h1: "Big 12 Football - 2nd Half Public Betting",
        description:
          "Check out BetQL for the latest Big 12 football 2nd half public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Football Public 2nd Half Picks | BetQL",
        h1: "Big 10 Football - 2nd Half Public Betting",
        description:
          "Check out BetQL for the latest Big 10 football 2nd half public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Football Public 2nd Half Picks | BetQL",
        h1: "CUSA Football - 2nd Half Public Betting",
        description:
          "Check out BetQL for the latest CUSA football 2nd half public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "fbs-independents": {
        seoTitle: "Independents Football Public 2nd Half Picks | BetQL",
        h1: "Independents Football - 2nd Half Public Betting",
        description:
          "Check out BetQL for the latest Independents football 2nd half public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mid-american": {
        seoTitle: "MAC Football Public 2nd Half Picks | BetQL",
        h1: "MAC Football - 2nd Half Public Betting",
        description:
          "Check out BetQL for the latest MAC football 2nd half public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "MW Football Public 2nd Half Picks | BetQL",
        h1: "MW Football - 2nd Half Public Betting",
        description:
          "Check out BetQL for the latest MW football 2nd half public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Football Public 2nd Half Picks | BetQL",
        h1: "Pac 12 Football - 2nd Half Public Betting",
        description:
          "Check out BetQL for the latest Pac 12 football 2nd half public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Football Public 2nd Half Picks | BetQL",
        h1: "SEC Football - 2nd Half Public Betting",
        description:
          "Check out BetQL for the latest SEC football 2nd half public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Football Public 2nd Half Picks | BetQL",
        h1: "Sun Belt Football - 2nd Half Public Betting",
        description:
          "Check out BetQL for the latest Sun Belt football 2nd half public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "second-half-moneylines": {
      seoTitle: "College Football 2nd Half Moneyline Public Picks | BetQL",
      h1: "College Football 2nd Half Money Line Public Picks",
      description:
        "Check out BetQL for the latest College Football money line consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAF Public Betting 2nd Half Moneyline All Conferences | BetQL",
        h1: "All College Football 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest College Football money line consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "american-athletic": {
        seoTitle: "AAC Football Public 2nd Half Money Line Picks | BetQL",
        h1: "AAC Football - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest AAC football 2nd half money line public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Football Public 2nd Half Money Line Picks | BetQL",
        h1: "ACC Football - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest ACC football 2nd half money line public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Football Public 2nd Half Money Line Picks | BetQL",
        h1: "Big 12 Football - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Big 12 football 2nd half money line public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Football Public 2nd Half Money Line Picks | BetQL",
        h1: "Big 10 Football - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Big 10 football 2nd half money line public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Football Public 2nd Half Money Line Picks | BetQL",
        h1: "CUSA Football - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest CUSA football 2nd half money line public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "fbs-independents": {
        seoTitle: "Independents Football Public 2nd Half Money Line Picks | BetQL",
        h1: "Independents Football - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Independents football 2nd half money line public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mid-american": {
        seoTitle: "MAC Football Public 2nd Half Money Line Picks | BetQL",
        h1: "MAC Football - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest MAC football 2nd half money line public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "MW Football Public 2nd Half Money Line Picks | BetQL",
        h1: "MW Football - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest MW football 2nd half money line public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Football Public 2nd Half Money Line Picks | BetQL",
        h1: "Pac 12 Football - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Pac 12 football 2nd half money line public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Football Public 2nd Half Money Line Picks | BetQL",
        h1: "SEC Football - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest SEC football 2nd half money line public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Football Public 2nd Half Money Line Picks | BetQL",
        h1: "Sun Belt Football - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Sun Belt football 2nd half money line public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    spread: {
      all: {
        seoTitle: "NCAAF Public Betting Spread All Conferences | BetQL",
        h1: "All College Football Public Betting",
        description:
          "Check out BetQL for the latest College Football ATS consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "american-athletic": {
        seoTitle: "AAC Football Public Spread Picks | BetQL",
        h1: "AAC Football - Public Betting",
        description:
          "Check out BetQL for the latest AAC football public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Football Public Spread Picks | BetQL",
        h1: "ACC Football - Public Betting",
        description:
          "Check out BetQL for the latest ACC football public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Football Public Spread Picks | BetQL",
        h1: "Big 12 Football - Public Betting",
        description:
          "Check out BetQL for the latest Big 12 football public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Football Public Spread Picks | BetQL",
        h1: "Big 10 Football - Public Betting",
        description:
          "Check out BetQL for the latest Big 10 football public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Football Public Spread Picks | BetQL",
        h1: "CUSA Football - Public Betting",
        description:
          "Check out BetQL for the latest CUSA football public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "fbs-independents": {
        seoTitle: "Independents Football Public Spread Picks | BetQL",
        h1: "Independents Football - Public Betting",
        description:
          "Check out BetQL for the latest Independents football public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mid-american": {
        seoTitle: "MAC Football Public Spread Picks | BetQL",
        h1: "MAC Football - Public Betting",
        description:
          "Check out BetQL for the latest MAC football public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "MW Football Public Spread Picks | BetQL",
        h1: "MW Football - Public Betting",
        description:
          "Check out BetQL for the latest MW football public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Football Public Spread Picks | BetQL",
        h1: "Pac 12 Football - Public Betting",
        description:
          "Check out BetQL for the latest Pac 12 football public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Football Public Spread Picks | BetQL",
        h1: "SEC Football - Public Betting",
        description:
          "Check out BetQL for the latest SEC football public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Football Public Spread Picks | BetQL",
        h1: "Sun Belt Football - Public Betting",
        description:
          "Check out BetQL for the latest Sun Belt football public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "totals-spread": {
      seoTitle: "College Football Public Over Under Picks | BetQL",
      h1: "All College Football Over Under Public Picks",
      description:
        "Check out BetQL for the latest College Football over under consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAF Public Betting Total All Conferences | BetQL",
        h1: "College Football Over Under Public Picks",
        description:
          "Check out BetQL for the latest College Football over under consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "american-athletic": {
        seoTitle: "AAC Football Public Over Under Picks | BetQL",
        h1: "AAC Football - Over Under Public Picks",
        description:
          "Check out BetQL for the latest AAC football over under public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Football Public Over Under Picks | BetQL",
        h1: "ACC Football - Over Under Public Picks",
        description:
          "Check out BetQL for the latest ACC football over under public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Football Public Over Under Picks | BetQL",
        h1: "Big 12 Football - Over Under Public Picks",
        description:
          "Check out BetQL for the latest Big 12 football over under public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Football Public Over Under Picks | BetQL",
        h1: "Big 10 Football - Over Under Public Picks",
        description:
          "Check out BetQL for the latest Big 10 football over under public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Football Public Over Under Picks | BetQL",
        h1: "CUSA Football - Over Under Public Picks",
        description:
          "Check out BetQL for the latest CUSA football over under public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "fbs-independents": {
        seoTitle: "Independents Football Public Over Under Picks | BetQL",
        h1: "Independents Football - Over Under Public Picks",
        description:
          "Check out BetQL for the latest Independents football over under public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mid-american": {
        seoTitle: "MAC Football Public Over Under Picks | BetQL",
        h1: "MAC Football - Over Under Public Picks",
        description:
          "Check out BetQL for the latest MAC football over under public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "MW Football Public Over Under Picks | BetQL",
        h1: "MW Football - Over Under Public Picks",
        description:
          "Check out BetQL for the latest MW football over under public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Football Public Over Under Picks | BetQL",
        h1: "Pac 12 Football - Over Under Public Picks",
        description:
          "Check out BetQL for the latest Pac 12 football over under public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Football Public Over Under Picks | BetQL",
        h1: "SEC Football - Over Under Public Picks",
        description:
          "Check out BetQL for the latest SEC football over under public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Football Public Over Under Picks | BetQL",
        h1: "Sun Belt Football - Over Under Public Picks",
        description:
          "Check out BetQL for the latest Sun Belt football over under public betting and consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
  },
  "sharp-picks": {
    seoTitle: "College Football Expert Picks | College Football Picks | BetQL",
    h1: "College Football Picks Against the Spread",
    description:
      "Check out BetQL for the latest College Football expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
    "first-half-lines": {
      seoTitle: "College Football 1st Half Expert Picks | NCAAF 1st Half Sharp Picks | BetQL",
      h1: "College Football 1st Half Picks Against the Spread",
      description:
        "Check out BetQL for the latest College Football 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAF Sharp Picks 1st Half Spread All Conferences | BetQL",
        h1: "All College Football 1st Half Picks",
        description:
          "Check out BetQL for the latest College Football 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "american-athletic": {
        seoTitle: "AAC Football 1st Half Expert Picks | BetQL",
        h1: "AAC Football - 1st Half Picks",
        description:
          "Check out BetQL for the latest AAC football 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Football 1st Half Expert Picks | BetQL",
        h1: "ACC Football - 1st Half Picks",
        description:
          "Check out BetQL for the latest ACC football 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Football 1st Half Expert Picks | BetQL",
        h1: "Big 12 Football - 1st Half Picks",
        description:
          "Check out BetQL for the latest Big 12 football 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Football 1st Half Expert Picks | BetQL",
        h1: "Big 10 Football - 1st Half Picks",
        description:
          "Check out BetQL for the latest Big 10 football 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Football 1st Half Expert Picks | BetQL",
        h1: "CUSA Football - 1st Half Picks",
        description:
          "Check out BetQL for the latest CUSA football 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "fbs-independents": {
        seoTitle: "Independents Football 1st Half Expert Picks | BetQL",
        h1: "Independent Football - 1st Half Picks",
        description:
          "Check out BetQL for the latest Independents football 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mid-american": {
        seoTitle: "MAC Football 1st Half Expert Picks | BetQL",
        h1: "MAC Football - 1st Half Picks",
        description:
          "Check out BetQL for the latest MAC football 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "MW Football 1st Half Expert Picks | BetQL",
        h1: "MW Football - 1st Half Picks",
        description:
          "Check out BetQL for the latest MW football 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Football 1st Half Expert Picks | BetQL",
        h1: "Pac 12 Football - 1st Half Picks",
        description:
          "Check out BetQL for the latest Pac 12 football 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Football 1st Half Expert Picks | BetQL",
        h1: "SEC Football - 1st Half Picks",
        description:
          "Check out BetQL for the latest SEC football 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Football 1st Half Expert Picks | BetQL",
        h1: "Sun Belt Football - 1st Half Picks",
        description:
          "Check out BetQL for the latest Sun Belt football 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "first-half-moneyline": {
      seoTitle: "College Football 1st Half Money Line Expert Picks | BetQL",
      h1: "College Football 1st Half Money Line Picks",
      description:
        "Check out BetQL for the latest College Football 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAF Sharp Picks 1st Half Moneyline All Conferences | BetQL",
        h1: "All College Football 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest College Football 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "american-athletic": {
        seoTitle: "AAC Football 1st Half Money Line Expert Picks | BetQL",
        h1: "AAC Football - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest AAC football 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Football 1st Half Money Line Expert Picks | BetQL",
        h1: "ACC Football - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest ACC football 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Football 1st Half Money Line Expert Picks | BetQL",
        h1: "Big 12 Football - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest Big 12 football 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Football 1st Half Money Line Expert Picks | BetQL",
        h1: "Big 10 Football - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest Big 10 football 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Football 1st Half Money Line Expert Picks | BetQL",
        h1: "CUSA Football - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest CUSA football 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "fbs-independents": {
        seoTitle: "Independents Football 1st Half Money Line Expert Picks | BetQL",
        h1: "Independent Football - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest Independents football 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mid-american": {
        seoTitle: "MAC Football 1st Half Money Line Expert Picks | BetQL",
        h1: "MAC Football - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest MAC football 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "MW Football 1st Half Money Line Expert Picks | BetQL",
        h1: "MW Football - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest MW football 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Football 1st Half Money Line Expert Picks | BetQL",
        h1: "Pac 12 Football - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest Pac 12 football 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Football 1st Half Money Line Expert Picks | BetQL",
        h1: "SEC Football - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest SEC football 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Football 1st Half Money Line Expert Picks | BetQL",
        h1: "Sun Belt Football - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest Sun Belt football 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "first-half-totals-spread": {
      seoTitle: "NCAAF Sharp Picks 1st Half Total Top 25 | BetQL",
      h1: "College Football 1st Half Over Under Expert Picks",
      description:
        "Check out BetQL for the latest College Football 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAF Sharp Picks 1st Half Total All Conferences | BetQL",
        h1: "All College Football 1st Half Over Under Expert Picks",
        description:
          "Check out BetQL for the latest College Football 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "american-athletic": {
        seoTitle: "AAC Football 1st Half Over Under Expert Picks | BetQL",
        h1: "AAC Football - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest AAC football 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Football 1st Half Over Under Expert Picks | BetQL",
        h1: "ACC Football - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest ACC football 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Football 1st Half Over Under Expert Picks | BetQL",
        h1: "Big 12 Football - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest Big 12 football 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Football 1st Half Over Under Expert Picks | BetQL",
        h1: "Big 10 Football - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest Big 10 football 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Football 1st Half Over Under Expert Picks | BetQL",
        h1: "CUSA Football - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest CUSA football 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "fbs-independents": {
        seoTitle: "Independents Football 1st Half Over Under Expert Picks | BetQL",
        h1: "Independent Football - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest Independents football 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mid-american": {
        seoTitle: "MAC Football 1st Half Over Under Expert Picks | BetQL",
        h1: "MAC Football - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest MAC football 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "MW Football 1st Half Over Under Expert Picks | BetQL",
        h1: "MW Football - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest MW football 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Football 1st Half Over Under Expert Picks | BetQL",
        h1: "Pac 12 Football - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest Pac 12 football 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Football 1st Half Over Under Expert Picks | BetQL",
        h1: "SEC Football - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest SEC football 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Football 1st Half Over Under Expert Picks | BetQL",
        h1: "Sun Belt Football - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest Sun Belt football 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    moneyline: {
      seoTitle: "College Football Expert Money Line Picks | BetQL",
      h1: "College Football Money Line Picks",
      description:
        "Check out BetQL for the latest College Football money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAF Sharp Picks Moneyline All Conferences | BetQL",
        h1: "All College Football Money Line Picks",
        description:
          "Check out BetQL for the latest College Football money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "american-athletic": {
        seoTitle: "AAC Football Money Line Expert Picks | BetQL",
        h1: "AAC Football - Money Line Picks",
        description:
          "Check out BetQL for the latest AAC football money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Football Money Line Expert Picks | BetQL",
        h1: "ACC Football - Money Line Picks",
        description:
          "Check out BetQL for the latest ACC football money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Football Money Line Expert Picks | BetQL",
        h1: "Big 12 Football - Money Line Picks",
        description:
          "Check out BetQL for the latest Big 12 football money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Football Money Line Expert Picks | BetQL",
        h1: "Big 10 Football - Money Line Picks",
        description:
          "Check out BetQL for the latest Big 10 football money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Football Money Line Expert Picks | BetQL",
        h1: "CUSA Football - Money Line Picks",
        description:
          "Check out BetQL for the latest CUSA football money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "fbs-independents": {
        seoTitle: "Independents Football Money Line Expert Picks | BetQL",
        h1: "Independent Football - Money Line Picks",
        description:
          "Check out BetQL for the latest Independents football money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mid-american": {
        seoTitle: "MAC Football Money Line Expert Picks | BetQL",
        h1: "MAC Football - Money Line Picks",
        description:
          "Check out BetQL for the latest MAC football money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "MW Football Money Line Expert Picks | BetQL",
        h1: "MW Football - Money Line Picks",
        description:
          "Check out BetQL for the latest MW football money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Football Money Line Expert Picks | BetQL",
        h1: "Pac 12 Football - Money Line Picks",
        description:
          "Check out BetQL for the latest Pac 12 football money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Football Money Line Expert Picks | BetQL",
        h1: "SEC Football - Money Line Picks",
        description:
          "Check out BetQL for the latest SEC football money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Football Money Line Expert Picks | BetQL",
        h1: "Sun Belt Football - Money Line Picks",
        description:
          "Check out BetQL for the latest Sun Belt football money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "second-half-lines": {
      seoTitle: "College Football 2nd Half Expert Picks | BetQL",
      h1: "College Football 2nd Half Picks",
      description:
        "Check out BetQL for the latest College Football 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAF Sharp Picks 2nd Half Spread All Conferences | BetQL",
        h1: "All College Football 2nd Half Picks",
        description:
          "Check out BetQL for the latest College Football 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "american-athletic": {
        seoTitle: "AAC Football 2nd Half Expert Picks | BetQL",
        h1: "AAC Football - 2nd Half Picks",
        description:
          "Check out BetQL for the latest AAC football 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Football 2nd Half Expert Picks | BetQL",
        h1: "ACC Football - 2nd Half Picks",
        description:
          "Check out BetQL for the latest ACC football 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Football 2nd Half Expert Picks | BetQL",
        h1: "Big 12 Football - 2nd Half Picks",
        description:
          "Check out BetQL for the latest Big 12 football 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Football 2nd Half Expert Picks | BetQL",
        h1: "Big 10 Football - 2nd Half Picks",
        description:
          "Check out BetQL for the latest Big 10 football 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Football 2nd Half Expert Picks | BetQL",
        h1: "CUSA Football - 2nd Half Picks",
        description:
          "Check out BetQL for the latest CUSA football 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "fbs-independents": {
        seoTitle: "Independents Football 2nd Half Expert Picks | BetQL",
        h1: "Independent Football - 2nd Half Picks",
        description:
          "Check out BetQL for the latest Independents football 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mid-american": {
        seoTitle: "MAC Football 2nd Half Expert Picks | BetQL",
        h1: "MAC Football - 2nd Half Picks",
        description:
          "Check out BetQL for the latest MAC football 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "MW Football 2nd Half Expert Picks | BetQL",
        h1: "MW Football - 2nd Half Picks",
        description:
          "Check out BetQL for the latest MW football 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Football 2nd Half Expert Picks | BetQL",
        h1: "Pac 12 Football - 2nd Half Picks",
        description:
          "Check out BetQL for the latest Pac 12 football 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Football 2nd Half Expert Picks | BetQL",
        h1: "SEC Football - 2nd Half Picks",
        description:
          "Check out BetQL for the latest SEC football 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Football 2nd Half Expert Picks | BetQL",
        h1: "Sun Belt Football - 2nd Half Picks",
        description:
          "Check out BetQL for the latest Sun Belt football 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "second-half-moneylines": {
      seoTitle: "College Football Expert 2nd Half Money Line Picks | BetQL",
      h1: "College Football 2nd Half Money Line Picks",
      description:
        "Check out BetQL for the latest College Football 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAF Sharp Picks 2nd Half Money Line All Conferences | BetQL",
        h1: "All College Football 2nd Half Money Line Picks",
        description:
          "Check out BetQL for the latest College Football 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "american-athletic": {
        seoTitle: "AAC Football 2nd Half Money Line Expert Picks | BetQL",
        h1: "AAC Football - 2nd Half Money Line Picks",
        description:
          "Check out BetQL for the latest AAC football 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Football 2nd Half Money Line Expert Picks | BetQL",
        h1: "ACC Football - 2nd Half Money Line Picks",
        description:
          "Check out BetQL for the latest ACC football 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Football 2nd Half Money Line Expert Picks | BetQL",
        h1: "Big 12 Football - 2nd Half Money Line Picks",
        description:
          "Check out BetQL for the latest Big 12 football 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Football 2nd Half Money Line Expert Picks | BetQL",
        h1: "Big 10 Football - 2nd Half Money Line Picks",
        description:
          "Check out BetQL for the latest Big 10 football 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Football 2nd Half Money Line Expert Picks | BetQL",
        h1: "CUSA Football - 2nd Half Money Line Picks",
        description:
          "Check out BetQL for the latest CUSA football 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "fbs-independents": {
        seoTitle: "Independents Football 2nd Half Money Line Expert Picks | BetQL",
        h1: "Independent Football - 2nd Half Money Line Picks",
        description:
          "Check out BetQL for the latest Independents football 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mid-american": {
        seoTitle: "MAC Football 2nd Half Money Line Expert Picks | BetQL",
        h1: "MAC Football - 2nd Half Money Line Picks",
        description:
          "Check out BetQL for the latest MAC football 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "MW Football 2nd Half Money Line Expert Picks | BetQL",
        h1: "MW Football - 2nd Half Money Line Picks",
        description:
          "Check out BetQL for the latest MW football 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Football 2nd Half Money Line Expert Picks | BetQL",
        h1: "Pac 12 Football - 2nd Half Money Line Picks",
        description:
          "Check out BetQL for the latest Pac 12 football 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Football 2nd Half Money Line Expert Picks | BetQL",
        h1: "SEC Football - 2nd Half Money Line Picks",
        description:
          "Check out BetQL for the latest SEC football 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Football 2nd Half Money Line Expert Picks | BetQL",
        h1: "Sun Belt Football - 2nd Half Money Line Picks",
        description:
          "Check out BetQL for the latest Sun Belt football 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    spread: {
      all: {
        seoTitle: "NCAAF Sharp Picks Spread All Conferences | BetQL",
        h1: "All College Football Picks Against the Spread",
        description:
          "Check out BetQL for the latest College Football ATS expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "american-athletic": {
        seoTitle: "AAC Football ATS Expert Picks | BetQL",
        h1: "AAC Football - Picks Against the Spread",
        description:
          "Check out BetQL for the latest AAC football expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Football ATS Expert Picks | BetQL",
        h1: "ACC Football - Picks Against the Spread",
        description:
          "Check out BetQL for the latest ACC football expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Football ATS Expert Picks | BetQL",
        h1: "Big 12 Football - Picks Against the Spread",
        description:
          "Check out BetQL for the latest Big 12 football expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Football ATS Expert Picks | BetQL",
        h1: "Big 10 Football - Picks Against the Spread",
        description:
          "Check out BetQL for the latest Big 10 football expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Football ATS Expert Picks | BetQL",
        h1: "CUSA Football - Picks Against the Spread",
        description:
          "Check out BetQL for the latest CUSA football expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "fbs-independents": {
        seoTitle: "Independents Football ATS Expert Picks | BetQL",
        h1: "Independent Football - Picks Against the Spread",
        description:
          "Check out BetQL for the latest Independents football expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mid-american": {
        seoTitle: "MAC Football ATS Expert Picks | BetQL",
        h1: "MAC Football - Picks Against the Spread",
        description:
          "Check out BetQL for the latest MAC football expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "MW Football ATS Expert Picks | BetQL",
        h1: "MW Football - Picks Against the Spread",
        description:
          "Check out BetQL for the latest MW football expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Football ATS Expert Picks | BetQL",
        h1: "Pac 12 Football - Picks Against the Spread",
        description:
          "Check out BetQL for the latest Pac 12 football expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Football ATS Expert Picks | BetQL",
        h1: "SEC Football - Picks Against the Spread",
        description:
          "Check out BetQL for the latest SEC football expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Football ATS Expert Picks | BetQL",
        h1: "Sun Belt Football - Picks Against the Spread",
        description:
          "Check out BetQL for the latest Sun Belt football expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "totals-spread": {
      seoTitle: "College Football Expert Over Under Picks | BetQL",
      h1: "College Football Over Under Expert Picks",
      description:
        "Check out BetQL for the latest College Football over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAF Sharp Picks Total All Conferences | BetQL",
        h1: "All College Football Over Under Expert Picks",
        description:
          "Check out BetQL for the latest College Football over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "american-athletic": {
        seoTitle: "AAC Football Over Under Expert Picks | BetQL",
        h1: "AAC Football - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest AAC football over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Football Expert Over Under Picks | BetQL",
        h1: "ACC Football - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest ACC football over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Football Expert Over Under Picks | BetQL",
        h1: "Big 12 Football - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest Big 12 football over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Football Expert Over Under Picks | BetQL",
        h1: "Big 10 Football - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest Big 10 football over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Football Expert Over Under Picks | BetQL",
        h1: "CUSA Football - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest CUSA football over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "fbs-independents": {
        seoTitle: "Independents Football Expert Over Under Picks | BetQL",
        h1: "Independent Football - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest Independents football over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mid-american": {
        seoTitle: "MAC Football Expert Over Under Picks | BetQL",
        h1: "MAC Football - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest MAC football over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "MW Football Expert Over Under Picks | BetQL",
        h1: "MW Football - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest MW football over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Football Expert Over Under Picks | BetQL",
        h1: "Pac 12 Football - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest Pac 12 football over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Football Expert Over Under Picks | BetQL",
        h1: "SEC Football - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest SEC football over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
  },
};
